import React from "react";

function PlantelesHeader({ search, onSearchChange, onlyChampions, onToggleChampions }) {
    return (
        <div className="flex flex-col gap-4 sm:gap-6 mb-6 sm:mb-10">
            <div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-2 sm:mb-3 border-l-4 border-red-500 pl-3 sm:pl-4 leading-tight">Planteles</h1>
                <p className="text-slate-400 text-base sm:text-lg font-medium max-w-3xl">
                    Explorá los equipos históricos del club y sus resultados en competencias nacionales e internacionales.
                </p>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                <label className="w-full sm:max-w-md">
                    <div className="flex items-center rounded-lg border border-white/10 bg-white/5 backdrop-blur-xl px-3 py-2.5 sm:py-2 focus-within:border-green-500/60 transition-colors">
                        <span className="text-slate-400 mr-2">
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                        </span>
                        <input
                            type="text"
                            value={search}
                            onChange={(event) => onSearchChange(event.target.value)}
                            placeholder="Buscar torneo, resultado o jugador..."
                            className="w-full bg-transparent text-sm sm:text-base text-slate-100 placeholder:text-slate-500 focus:outline-none"
                        />
                        {search && (
                            <button
                                type="button"
                                onClick={() => onSearchChange("")}
                                className="ml-2 text-slate-400 hover:text-slate-200 transition-colors"
                                aria-label="Borrar búsqueda"
                            >
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                                    <path d="M18 6 6 18M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>
                </label>

                <button
                    type="button"
                    onClick={onToggleChampions}
                    className={`w-full sm:w-auto sm:ml-2 h-10 px-4 rounded-lg border text-sm font-semibold transition-colors ${onlyChampions
                        ? "border-green-500 bg-green-500/15 backdrop-blur-xl text-green-300"
                        : "border-white/10 bg-white/5 backdrop-blur-xl text-slate-300 hover:bg-white/10"
                        }`}
                >
                    {onlyChampions ? "Ver todos" : "Campeones"}
                </button>
            </div>
        </div>
    );
}

export default PlantelesHeader;
